export default __webpack_public_path__ + "b17fbf04861635bca5da0823f5e36e24.jpg";